// extracted by mini-css-extract-plugin
export default {"post_detail":"PostDetail_post_detail__4x4Pb","post_image":"PostDetail_post_image__aVP2w","tags":"PostDetail_tags__7OOVV","createdby":"PostDetail_createdby__I-vd-"};